import gql from 'graphql-tag';

import STATUS_DOCKETS_FRAGMENT from './STATUS_DOCKETS_FRAGMENT';

const CHANGE_SERVICE_RUN_MACHINES = gql`
	mutation changeServiceRunMachines (
		$machineIds: [ID!],
		$serviceRunId: ID!,
	) {
		changeServiceRunMachines (
			machineIds: $machineIds,
			serviceRunId: $serviceRunId,
		) {
			id
			cashReconciliationStatus
			routeOrderCalculationStatus
			routeOrderCalculationError
			serviceDockets {
				...statusDockets
			}
		}
	}
	${STATUS_DOCKETS_FRAGMENT}
`;

export default CHANGE_SERVICE_RUN_MACHINES;
